<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre7" id="lost-farm-camp"><div class="level" id="chapter-ivthe-compact">
<span id="the-compact"></span><h2 class="level1" id="pgepubid00003"><span class="calibre13">CHAPTER IV<br class="calibre12"/>THE COMPACT</span></h2>
<p class="align-center2"><span>“After fresh meat?” asked Ross.</span></p>
<p class="calibre14"><span>“Nope. Lookin’ fur a man.”</span></p>
<p class="calibre14"><span>Avery’s good eye closed suggestively
and he grinned. Standing his rifle in the crotch
of a cedar, he drew a plug of tobacco from his
pocket and carefully shaved a pipeful from it.
Then he smoked, squatting beside David as he
gazed across the lake.</span></p>
<p class="calibre14"><span>“Purty lake, ain’t it?”</span></p>
<p class="calibre14"><span>“Yes, it is,” replied David.</span></p>
<p class="calibre14"><span>“Chuck full of trout—big fellers, too. Ever do
any fishin’?”</span></p>
<p class="calibre14"><span>“A little. I like it.”</span></p>
<p class="calibre14"><span>“Slithers of deer in thet piece across thar,”
pointing with his pipestem to the foot of Timberland
Mountain. “Ever do any huntin’?”</span></p>
<p class="calibre14"><span>“Not much. Been after deer once or twice.”</span></p>
<p class="calibre14"><span>“Must have been suthin’ behind thet poke you
gave Fisty this mornin’, I take it?”</span></p>
<p class="calibre14"><span>“About one hundred and seventy pounds,” replied
David, smiling.
Avery chuckled his appreciation. Evidently
this young man didn’t “pump” easily.</span></p>
<p class="calibre14"><span>Puff—puff—“Reckon you never done no
trappin’.”</span></p>
<p class="calibre14"><span>“No, I don’t know the first thing about it.”</span></p>
<p class="calibre14"><span>Avery was a trifle disconcerted at his companion’s
taciturnity. He smoked for a while, covertly
studying the other’s face.</span></p>
<p class="calibre14"><span>“Reckon you’re goin’ back to Tramworth—mebby
goin’ to quit the woods, seein’ as you and
Fisty ain’t calc’lated to do any hefty amount of
handshakin’ fur a while?”</span></p>
<p class="calibre14"><span>“Yes, I’m going back, to get work of some
kind that will keep me up here. I wanted to learn
a bit about lumbering. I think I began the wrong
way.”</span></p>
<p class="calibre14"><span>“Don’t jest feel sartain about thet, m’self.
Howcome mebby Harrigan do, and he’s boss.
He would have put you on swampin’ at one plunk
a day and your grub. Reckon thet ain’t turrible
big pay fur a eddicated man. They’s ’bout six
months’ work and then you git your see-you-later
pay-check fur what the supply store ain’t a’ready
got.”</span></p>
<p class="calibre14"><span>“It’s pretty thin picking for some of the boys,
I suppose,” said David.</span></p>
<p class="calibre14"><span>“Huh! Some of ’em’s lucky to have their
britches left to come out in.”</span></p>
<p class="calibre14"><span>“I didn’t expect to get rich at it, but I wanted
the experience,” replied David, wondering why
Avery seemed so anxious to impress him with
the wage aspect of lumbering.</span></p>
<p class="calibre14"><span>“Don’t calc’late you ever did any spec’latin’,
did you?”</span></p>
<p class="calibre14"><span>“Well, I have done some since I had my fuss
with Harrigan this morning.”</span></p>
<p class="calibre14"><span>Avery tugged at his beard thoughtfully.</span></p>
<p class="calibre14"><span>“I’m turnin’ a penny onct in a while or frequenter.
With the trappin’ winters, feedin’ the
crews goin’ in and comin’ out, makin’ axe-handles
and snowshoes, and onct in a spell guidin’ some
city feller in the fall up to whar he kin dinnimite
a moose, I reckon six hundred dollars wouldn’t
cover my earnin’s. I could do more trappin’ if I
had a partner. Mebby me and him could make nigh
on to five hundred a year, and grub.”</span></p>
<p class="calibre14"><span>“That’s pretty good,—five hundred clear,
practically.”</span></p>
<p class="calibre14"><span>“Ya-a-s.” Avery grunted and stood up, thrusting
his pipe in his pocket. “Said I was huntin’
fur a man when you ast me. You’re the man I
be huntin’ fur if you want a job bad ’nough to
hitch up with me, and Swickey.”</span></p>
<p class="calibre14"><span>Ross arose and faced him, his surprise evident
in the blank expression of his face.</span></p>
<p class="calibre14"><span>“I’m not out of cash,” he replied.</span></p>
<p class="calibre14"><span>“Thet ain’t what I ast you fur,” said Avery,
a shade of disappointment flickering across his
face. “I want a man to help.”</span></p>
<p class="calibre14"><span>“How much would it cost to outfit?” asked
David.</span></p>
<p class="calibre14"><span>“Wal, I got a hundred and fifty traps, and
mebby we could use fifty more, not countin’ dead-falls
for b’ar and black-cat. And you sure need a
rifle and some blankets and some winter clothes.
I figure fifty plunks would fit you out.”</span></p>
<p class="calibre14"><span>“I didn’t know but that you would want me
to put up some cash toward expenses,—provisions,
I mean?”</span></p>
<p class="calibre14"><span>“No,” said Avery. “I reckon you ain’t broke,
but thet ain’t makin’ any diff’runce to me.”</span></p>
<p class="calibre14"><span>“That’s all right, Avery. It wasn’t the expense
of outfitting. I simply wanted to know
where I would stand if I did accept. But I have
no recommendations, no letters—”</span></p>
<p class="calibre14"><span>“Hell! I guess them two hands of your’n is
all the recommendations I want. I’ve fit some
m’self and be reckoned a purty fair jedge of
hosses, and a man what is a good jedge of hosses
knows folks likewise. I ain’t in no hurry fur you
to say yes or no.” The old man swung his rifle to
the hollow of his arm. “Take your time to think
on it, and you kin stay to Lost Farm Camp jest
as long as you are wishful. ’Tain’t every day a
eddicated man what kin use his hands comes
floatin’ into these here woods.”</span></p>
<p class="calibre14"><span>“Well,” said David, “I’ve decided. There
are reasons why I don’t want to go back. It’s a
fair offer and I’ll take it.”</span></p>
<p class="calibre14"><span>“Put her thar!” the huge bony fist of the
lumberman closed heavily on David’s hand, but
met a grip almost as tense. “Me and you’s
partners. Half-and-half share of workin’, eatin’,
earnin’s, and fightin’—if there’s any fightin’ to
be did. Reckon you’d better go to Tramworth
and git fixed up and mebby you calc’late to
write to your folks.”</span></p>
<p class="calibre14"><span>They strode down the trail, Avery in the lead.
As they neared the last turn which led them out
to the footboard of the dam, he paused.</span></p>
<p class="calibre14"><span>“My gal Swickey is growin’ up to whar she
oughter git larnin’. I sot in to learn her, but
she’s always a-squirmin’ out of it by askin’ me
things what I can’t answer and then gettin’ riled
at her Pa. Now if you could—’thout lettin’ on
as you was doin’ it—larn her readin’ and writin’
and sech, I’d be pow’ful glad to pay you extra-like
fur it.”</span></p>
<p class="calibre14"><span>So the cat was out of the bag at last. Avery
wanted a teacher for his girl. The old man
was willing to take a green hand as partner in
trapping and share the proceeds with him for
the sake of Swickey’s education. Well, why
not?</span></p>
<p class="calibre14"><span>“I’ll do what I can, Avery.”</span></p>
<p class="calibre14"><span>“Thet’s the talk. Me and you’ll make a lady
of her.”</span></p>
<p class="calibre14"><span>As they approached the cabin a figure appeared
in the doorway and the melodious treble of a
girl’s voice rang across the river. She disappeared
as Avery’s Triton bellow answered.</span></p>
<p class="calibre14"><span>“She’s callin’ us fur dinner,” he explained
needlessly.</span></p>
<p class="calibre14"><span>“Did you get anything?” said Swickey, as they
entered the cabin.</span></p>
<p class="calibre14"><span>“He bagged me,” said Ross, laughing.</span></p>
<p class="calibre14"><span>“Whar’d he bag you?” exclaimed Swickey,
solicitously looking at David for visible proof of
her father’s somewhat indifferent marksmanship.</span></p>
<p class="calibre14"><span>“Over on No-Man’s Lake—I think that’s
what he called it,” replied David.</span></p>
<p class="calibre14"><span>“He’s a-goin’ to stay, right along now. I’ve
been wantin’ to git a partner to help with the
traps fur quite a spell.”</span></p>
<p class="calibre14"><span>“You ain’t never said nothin’ to me ’bout gettin’
a partner,” said Swickey, her vanity wounded.
“You always said I was as good as any two men
helpin’ you.”</span></p>
<p class="calibre14"><span>Avery, a trifle embarrassed at his daughter’s
reception of the new partner, maintained an uncomfortable
silence while dinner was in progress.
He had hoped for delight from her, but
she sat stolidly munching her food with conscious
indifference to his infrequent sallies.</span></p>
<p class="calibre14"><span>That evening, after David had gone to bed in
the small cabin back of the camp, Avery sat on
the porch with his daughter. For a long time she
cuddled the kitten, busily turning over in her
mind the possibilities of a whole dollar and a half.
She had heard her father say that the new man
was going to Tramworth in the morning. Perhaps
he would be able to get her a dress. A dollar
and a half was a whole lot of money. Maybe
she could buy Pop some new “specs” with what
she had left after purchasing the dress. Or if
she had a book, a big one that would tell how to
make dresses and everything, maybe </span><em class="italics">that</em><span> would
be better to have. Jessie Cameron could sew
doll’s clothes, but her mother had taught her.
The fact that Swickey could not read did not occur
to her as relevant to the subject. She felt, in
a vague way, that the book itself would overcome
all obstacles. Yes, she would ask the new man to
buy a book for her and “specs” for her Pop. How
to accomplish this, unknown to her father, was a
problem she set aside with the ease of optimistic
childhood, to which nothing is impossible.</span></p>
<p class="calibre14"><span>“Pop,” she said suddenly.</span></p>
<p class="calibre14"><span>“Wal?”</span></p>
<p class="calibre14"><span>“Mebby you kin give me thet dollar-money
fur the ile.”</span></p>
<p class="calibre14"><span>“Ya-a-s,” he drawled, secretly amused at her
sudden interest in money and anxious to reinstate
himself in her favor. “Ya-a-s, but what you
goin’ to do? Buy Pop thet dress-suit, mebby?”</span></p>
<p class="calibre14"><span>“I reckon not,” she exclaimed with an unexpected
show of heat that astonished him. “You
said dress-suits made folks ack foolish, and I
reckon some folks acks foolish ’nough right in
the clothes they has on without reskin’ changin’
’em.” With this gentle insinuation, she gathered
Beelzebub in her arms and marched to her
room.</span></p>
<p class="calibre14"><span>“Gosh-A’mighty but Swickey’s gettin’ tetchy,”
he exclaimed, grinning. “Wal, she’s a-goin’ to
have a new dress if I have to make it myself.”</span></p>
<p class="calibre14"><span>When he went into the cabin, he drew a chair
to the table and, sitting down, took two silver
pieces from his pocket and laid them on Swickey’s
plate. He sat for a long time shading his eyes
with his hand. He nodded, recovered, nodded
again. Then he said quite distinctly, but in the
voice of one walking in dreams, “I know it,
Nanette. Yes, I know it. I’m doin’ the best I
kin—”</span></p>
<p class="calibre14"><span>He sat up with a start, saw the silver pieces on
the plate and picked them up.</span></p>
<p class="calibre14"><span>“Swickey!” he called, “be you sleepin’?”</span></p>
<p class="calibre14"><span>“Yes, Pop,” she replied dutifully.</span></p>
<p class="calibre14"><span>He grinned as he went to her room. As he
bent over her she found his head in the dark,
and kissed him. “I’m sorry what I said ’bout
the clothes, Pop. I don’t want no money-dollar—I
jest want you.”</span></p>
<p class="calibre14"><span>He tucked the money in her hand. “Thar it is.
Dollar and a half fur the ile.”</span></p>
<p class="calibre14"><span>She sighed happily. “I say thanks to my
Pop.”</span></p>
<p class="calibre14"><span>“Good-night, leetle gal.”</span></p>
<p class="calibre14"><span>She lay awake long after he had left her, turning
the coins over in her hot fingers. Presently
she slipped from the bed and, drawing the blanket
about her, stole softly to the door.</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?25d4f3a6